import type { InputHTMLAttributes, ReactNode } from 'react';
import React from 'react';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

import Toggle from 'components/Toggle/Toggle';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

type FormTogglePropsT<FormValuesT> = InputHTMLAttributes<HTMLInputElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
  value?: string | boolean;
};

const FormToggle = <FormValuesT,>({
  name,
  ...restProps
}: FormTogglePropsT<FormValuesT>): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const { ref, onChange, onBlur } = register(name);

  return (
    <>
      <Toggle ref={ref} onChange={onChange} onBlur={onBlur} name={name} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormToggle;
